export const tro20DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/20-yard",
      name: "20 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/20-yard/20-yd-header.jpg",
      description:
        "Our 20 yard dumpster rentals are the perfect solution for large projects such as home and garage cleanouts or business renovations. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/20-yard/20-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/20-yard/20-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "20 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "20-Yard" },
      ],
    },
  ],
}

export const tro20ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/20-yard/#product",
  name: "20 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/20-yard/20-yd-header.jpg",
  description:
    "Typically measuring 21’11” x 7’ x 3’6”, our 20 yard dumpsters are just the solution to manage waste disposal for larger home projects like attic or basement cleanouts and kitchen or bathroom remodels; as well as business renovations. Conveniently schedule delivery and manage pickups online.",
  url: "https://www.wm.com/us/en/dumpster-rental/20-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/20-yard",
  isRelatedTo: [
    "10 Yard Dumpster",
    "12 Yard Dumpster",
    "15 Yard Dumpster",
    "30 Yard Dumpster",
    "40 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
